module.exports = __webpack_public_path__ + "static/media/beFTM.c1e2c9c4.svg";